import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import { OPERATIONAL_EVENT_TYPE, source, errorBoundaryAction, errorBoundaryActionSubject } from './constants';
const name = "@atlassiansox/cross-flow-support";
const version = "3.12.0";
const payload = {
  eventType: OPERATIONAL_EVENT_TYPE,
  action: errorBoundaryAction,
  actionSubject: errorBoundaryActionSubject
};
const context = [{
  source
}, {
  packageName: name,
  packageVersion: version
}];
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    this.props.onAnalyticsEvent({
      payload,
      context
    });
    if (this.props.onError) {
      this.props.onError(error);
    }
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}